import React from 'react';
import { Footer } from '../components/Footer';

export function Docs() {
  return (
    <div className="min-h-screen bg-white">
      <div className="mx-auto max-w-4xl px-6 py-16">
        <div className="text-center mb-12">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">MemPalace 文档</h1>
          <p className="text-lg text-gray-600">
            学习如何使用 MemPalace 管理你的记忆。
          </p>
        </div>

        <div className="space-y-8">
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">开始使用</h2>
            <p className="text-gray-600 mb-4">
              MemPalace 是一个简单的记忆管理系统，让你能够更好地整理和记住重要的事情。
            </p>
          </section>

          <section>
            <h3 className="text-xl font-semibold text-gray-900 mb-4">基本概念</h3>
            <div className="space-y-3">
              <div>
                <h4 className="font-medium text-gray-900">记忆单元</h4>
                <p className="text-gray-600">你的每一条记忆都是一个单元</p>
              </div>
              <div>
                <h4 className="font-medium text-gray-900">双向链接</h4>
                <p className="text-gray-600">让记忆之间自然连接</p>
              </div>
              <div>
                <h4 className="font-medium text-gray-900">知识图谱</h4>
                <p className="text-gray-600">可视化的记忆关系络</p>
              </div>
            </div>
          </section>

          <section>
            <h3 className="text-xl font-semibold text-gray-900 mb-4">基本操作</h3>
            <div className="space-y-4">
              <div className="bg-gray-50 rounded-lg p-4">
                <h4 className="font-medium text-gray-900 mb-2">添加记忆</h4>
                <p className="text-gray-600">在主界面点击添加按钮，输入内容并添加标签</p>
              </div>
              <div className="bg-gray-50 rounded-lg p-4">
                <h4 className="font-medium text-gray-900 mb-2">搜索记忆</h4>
                <p className="text-gray-600">使用顶部搜索框找到相关内容</p>
              </div>
              <div className="bg-gray-50 rounded-lg p-4">
                <h4 className="font-medium text-gray-900 mb-2">查看图谱</h4>
                <p className="text-gray-600">点击图谱按钮可以看到记忆的连接关系</p>
              </div>
            </div>
          </section>
        </div>
      </div>
      
      <Footer />
    </div>
  );
}
